import { useState } from "react";
import { translate } from "../../utils/translation";
import PropTypes from "prop-types";

import Spinner from "../common/Spinner";

DeletePDFButton.propTypes = {
  updateFunction: PropTypes.func,
};

export function DeletePDFButton(props) {
  const { updateFunction } = props;

  const [isDeleting, setIsDeleting] = useState(false);

  if (isDeleting) {
    return <Spinner width={"20px"} />;
  }

  return (
    <button
      className="pdf-delete-button"
      onClick={async () => {
        const confirm = window.confirm(
          `Confirm delete this PDF? This cannot be undone.`
        );

        if (!confirm) {
          return;
        }

        setIsDeleting(true);
        //Call the delete api
        await updateFunction();
        setIsDeleting(false);
      }}
    >
      {translate("Delete")}
    </button>
  );
}
